/**
 * Emma Page State - Global Store (Non-React)
 * 
 * Simple global store for Emma's page context.
 * Avoids React re-render cascades by using plain JS.
 * 
 * Usage:
 * - Dashboard/pages: setEmmaPageState({ entityCounts, userJourneyStage, ... })
 * - UniversalEmmaChat: getEmmaPageState() when sending API requests
 */

export interface PageState {
  isEmpty?: boolean;
  entityCounts?: {
    clients: number;
    partners: number;
    vendors: number;
    solutions: number;
  };
  campaignCount?: number;
  visibleButtons?: string[];
  primaryMessage?: string;
  userJourneyStage?: 'onboarding' | 'active' | 'returning';
  errorState?: string;
  dataLoading?: boolean;
}

// Global store - NOT React state, avoids re-render cascades
let _pageState: PageState = {};

/**
 * Set page state (called by Dashboard, EntityManager, etc.)
 */
export function setEmmaPageState(state: Partial<PageState>): void {
  _pageState = { ..._pageState, ...state };
}

/**
 * Get current page state (called by UniversalEmmaChat when sending API)
 */
export function getEmmaPageState(): PageState {
  return { ..._pageState };
}

/**
 * Clear page state (called on page navigation if needed)
 */
export function clearEmmaPageState(): void {
  _pageState = {};
}
